import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home';
import Subscribe from './Pages/Subscribe';
import GetHeaders from './Pages/GetHeaders';
import {Routes,Route,Navigate} from 'react-router-dom'
import Welcome from './Pages/Welcome';
import Otp from './Pages/Otp';
import Tnc from './Pages/Tnc';
import { ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
       <ToastContainer/>

    <Routes>
      <Route path="/subscribe" element={<Subscribe/>} />
      <Route path="/otp-validation" element={<Otp/>} />
      <Route path="/header"  element={<GetHeaders/>}/>
      <Route path="/welcome" element={<Welcome/>} />
      <Route path="/Tnc"  element={<Tnc/>}/>
      <Route path="*" element={<Navigate to="/welcome" />} />
    </Routes>
    </>
  );
}

export default App;
